import React, { ComponentProps } from 'react'
import { useTranslation } from 'hooks/useTranslation'
import {
  WhatYouNeedRoot,
  Feature,
  ButtonWrapper,
  FeatureColumn,
  ImageWrapper,
  WhatYouNeedBox,
  Header,
  ImageColumn,
  Subheader,
} from './WhatYouNeed.styles'
import { Text } from 'components/Text'
import Image from 'next/image'
import { Icon } from 'components/Icon'
import { Button } from 'components/Button'
import fullTime from '../../../../../../../public/assets/home/full-time-job.webp'
import Link from 'next/link'
import { Stack } from 'components/Stack'

type WhatYouNeedOwnProps = ComponentProps<typeof WhatYouNeedRoot>
export type WhatYouNeedProps = WhatYouNeedOwnProps & {
  howItWorks?: boolean
}

export const WhatYouNeed = (_props: WhatYouNeedProps) => {
  const { t } = useTranslation()
  const { howItWorks = false } = _props
  return (
    <WhatYouNeedRoot>
      <Header className="d-only">{t('products-v2:benefits.title')}</Header>
      <WhatYouNeedBox>
        <ImageColumn>
          <ImageWrapper>
            <Image objectFit='cover' layout="fill" src={fullTime} alt={t('home:mealPlan.image')} />
          </ImageWrapper>
        </ImageColumn>
        {!howItWorks && <Header className="m-only">{t('products-v2:benefits.title')}</Header>}
        <FeatureColumn>
          {howItWorks && (
            <Subheader>{t('recipes:freeze-dried.how-it-works-subtitle')}</Subheader>
          )}
          <Feature>
            <Icon size="5" color="primary-500" name="checkbox-circle-line" />
            <Text size="body">{t('products-v2:benefits.items.0.text')}</Text>
          </Feature>
          <Feature>
            <Icon size="5" color="primary-500" name="checkbox-circle-line" />
            <Text size="body">{t('products-v2:benefits.items.1.text')}</Text>
          </Feature>
          <Feature>
            <Icon size="5" color="primary-500" name="checkbox-circle-line" />
            <Text size="body">{t('products-v2:benefits.items.2.text')}</Text>
          </Feature>
          <Feature>
            <Icon size="5" color="primary-500" name="checkbox-circle-line" />
            <Text size="body">{t('products-v2:benefits.items.3.text')}</Text>
          </Feature>
          <Feature>
            <Icon size="5" color="primary-500" name="checkbox-circle-line" />
            <Text size="body">{t('products-v2:benefits.items.4.text')}</Text>
          </Feature>
          {howItWorks && (
            <Stack css={{marginTop: '$1'}} display={{'@initial': 'none', '@bp2': 'flex'}}>
              <Link passHref href="/meal-plan">
                <Button>{t('products-v2:cta')}</Button>
              </Link>
            </Stack>
          )}
        </FeatureColumn>
      </WhatYouNeedBox>
      {!howItWorks && (
        <ButtonWrapper>
          <Link passHref href="/meal-plan">
            <Button>{t('products-v2:cta')}</Button>
          </Link>
        </ButtonWrapper>
      )}
    </WhatYouNeedRoot>
  )
}

WhatYouNeed.displayName = 'WhatYouNeed'
